import { useParams } from "react-router-dom";
import { useGetSeedLot, useGetCurrentUser } from "../../../api";
import Page from "../../../Containers/Page";
import ViewSeedLot from "../../../Sections/ViewSeedLot";
import getApiStatusPage from "../../APIStatusPage";

function SeedLotPage() {
  const { seedLotRef } = useParams();
  const getSeedLotApi = useGetSeedLot({
    seedLotRef,
    params: {
      fields:
        "reference,population,parentLot,parentProduct,isInitialLot,date,quantityKg,isArchived,issuedBy,receivedBy",
      "populate[receivedBy]": "tradingName,business_Reference",
      "populate[issuedBy]": "tradingName,business_Reference",
      "populate[population]": "name,reference",
      "populate[parentLot]": "reference",
      "populate[parentProduct]":
        "reference,DON,ZON,bunt,germinationRate,gluten,hagberg,moistureContent,protein,septoria,specificWeight,thousandGrainWeightGrams",
      includeLineageData: true,
    },
  });
  const useGetCurrentUserApi = useGetCurrentUser();
  const canEdit =
    useGetCurrentUserApi?.data?.user?.permissions?.writePopulations;
  const seedLot = getSeedLotApi?.data?.seedLot;
  const lineageData = getSeedLotApi?.data?.lineageData;

  const statusPage = getApiStatusPage({
    apis: [
      {
        api: getSeedLotApi,
        type: "Seed Lot",
        dataRequired: true,
      },
    ],
  });
  if (statusPage) return statusPage;

  return (
    <Page title={`Seed Lot - ${seedLotRef}`}>
      <ViewSeedLot
        seedLot={seedLot}
        lineageData={lineageData}
        getSeedLotLink={(ref) => `/admin/seed-lots/${ref}`}
        getBusinessLink={(ref) => `/admin/businesses/${ref}`}
        getPopulationLink={(ref) => `/admin/populations/${ref}`}
        canEdit={canEdit}
      />
    </Page>
  );
}

export default SeedLotPage;
